/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetAccountQueryResponse } from '../types/GetAccount.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetAccountUrl() {
  const res = { method: 'GET', url: `/account` as const };
  return res;
}

/**
 * @description Get current account
 * @summary Get current account
 * {@link /account}
 */
export async function getAccount(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetAccountQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetAccountUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
